import History from '@core/scripts/components/history';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Topics from '@core/scripts/components/topics';

function initById(name, rootElementId, closeCallback) {
    let observer = new MutationObserver((mutationRecords) => {

        const added = mutationRecords.some((record) =>
            Array.from(record.addedNodes).some((node) => node.id === rootElementId)
        );
        const removed = mutationRecords.some((record) =>
            Array.from(record.removedNodes).some((node) => node.id === rootElementId)
        );

        if (added && !removed) {
            History.push(name);

        } else if (removed && !added) {
            History.pop(name);
        }
    });
    observer.observe(document.body, { childList: true });
    MessageBroker.subscribe(`${Topics.HISTORY}.${name}`, function(event){
        if (event) {
            event.preventDefault();
        }
        if(closeCallback){
            closeCallback();
        }
    });
}

export default {
    initById
}
